import api from "./client";

// Stress-test admission tuning (fleet caller tasks only). Editable at runtime.
// Applies to PROVISIONED fleet servers; live calls and small on-box tests use
// the standard limit. See AdminStressAdmission.
export const stressAdmissionAPI = {
  get: () => api.get("/admin/stress_admission_config").then((r) => r.data),
  update: (body) => api.patch("/admin/stress_admission_config", body).then((r) => r.data),
};
